import React from "react";
import s from "./Switcher.module.css";
import Link from "../../_shared/Link";

function Chevron() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M6.75 13.5L11.25 9L6.75 4.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function Switcher({ tabs, active, setActive, links = [], children }) {
  return (
    <div className={s.switcher}>
      {tabs.map((tab) => (
        <React.Fragment key={tab.id}>
          <div
            className={`${s.switch} ${
              active === tab.id ? s["active-switch"] : ""
            }`}
            onMouseEnter={() => setActive(tab.id)}
          >
            {active === tab.id ? (
              <img src={tab.active_icon} alt={tab.title} />
            ) : (
              <img src={tab.icon} alt={tab.title} />
            )}

            <div className={s.title}>
              <div>{tab.title}</div>
              <Chevron />
            </div>
          </div>
          {active === tab.id && children}
        </React.Fragment>
      ))}

      {links.length > 0 &&
        links.map((item) => (
          <React.Fragment key={item.id}>
            <div className={s.switch}>
              <Link settings={item.link} className={s["link-switch"]}>
                {item.link.label}
                {item.tag && (
                  <em style={{ backgroundColor: item.tag_color }}>
                    {item.tag}
                  </em>
                )}
              </Link>
            </div>
          </React.Fragment>
        ))}
    </div>
  );
}

export default Switcher;
